
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/products/premium_patches",
      function () {
        return require("private-next-pages/store/products/premium_patches.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/products/premium_patches"])
      });
    }
  